// src/utils/dayOfWeekChartUtils.js

/**
 * Build the Chart.js data object for Discount Amount by Day of Week.
 * Optionally include other base datasets (e.g., Dine-in, GrabFood, Take-out).
 *
 * @param {number[]} discountAmountsPerDay - Array of 7 numbers: Sun -> Sat
 * @param {Array<object>} [baseDatasets=[]] - Other Chart.js dataset objects to include first
 * @returns {{ labels: string[], datasets: Array }}
 */
export function getDayOfWeekDiscountChartData(discountAmountsPerDay) {
  const labels = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const discountDataset = {
    label: "Discount Amount",
    data: discountAmountsPerDay,
    borderColor: "rgb(234, 67, 53)",
    backgroundColor: "rgba(234, 67, 53, 0.5)",
    fill: true,
  };

  return {
    labels,
    datasets: [discountDataset],
  };
}

/**
 * Build the Chart.js options object for a stacked chart by Day of Week.
 *
 * @returns {object} Chart.js options
 */
export function getDayOfWeekChartOptions() {
  return {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Total Transactions vs Discount by Day of Week",
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };
}
